import { Component, Input } from '@angular/core'
import { NgClass, NgForOf } from '@angular/common'
import { Size } from '@engineering11/ui-lib/e11-ui-config'

@Component({
  selector: 'ui-candidate-stars',
  standalone: true,
  template: `
    <span class="e11-flex e11-cursor-pointer {{ containerClass }}">
      <span
        *ngFor="let star of fullStars(starRating || 0)"
        class="material-icons-outlined e11-text-[#ffcc00]"
        [ngClass]="{
          'md-14': size === 'sm',
          'md-18': size === 'md',
          'md-24': size === 'lg',
          'md-36': size === 'xl',
        }"
      >
        star
      </span>
      <span
        *ngFor="let star of emptyStars(starRating || 0)"
        class="material-icons-outlined e11-text-skin-light"
        [ngClass]="{
          'md-14': size === 'sm',
          'md-18': size === 'md',
          'md-24': size === 'lg',
          'md-36': size === 'xl',
        }"
      >
        star
      </span>
    </span>
  `,
  imports: [NgForOf, NgClass],
})
export class UiCandidateStarsComponent {
  @Input() starRating = 0
  @Input() containerClass?: string
  @Input() size: Size = 'md'

  constructor() {}

  fullStars(n: number) {
    return Array(n)
  }

  emptyStars(fullStars: number) {
    const STAR_TOTAL = 5
    return Array(STAR_TOTAL - fullStars)
  }
}
